import { render, staticRenderFns } from "./SuppliesButton.vue?vue&type=template&id=20c083f1"
import script from "./SuppliesButton.vue?vue&type=script&lang=js"
export * from "./SuppliesButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports